import React, { useEffect, useState } from "react";
import { motion } from "framer-motion";
import api from "@/lib/api";
import { GuideCard } from "@/components/Cards";

const CATEGORIES = [
  { key: "all", label: "All" },
  { key: "weekend", label: "Weekend" },
  { key: "beaches", label: "Beaches" },
  { key: "restaurants", label: "Restaurants" },
  { key: "family", label: "Family" },
  { key: "hidden-gems", label: "Hidden Gems" },
  { key: "wellness", label: "Wellness" },
];

export default function Guides() {
  const [items, setItems] = useState([]);
  const [cat, setCat] = useState("all");

  useEffect(() => {
    api.get("/guides", { params: { category: cat } }).then((r) => setItems(r.data));
  }, [cat]);

  const [hero, ...rest] = items;

  return (
    <div className="max-w-[1400px] mx-auto px-6 lg:px-10 pt-16 pb-24">
      <motion.div initial={{ opacity: 0, y: 20 }} animate={{ opacity: 1, y: 0 }}>
        <span className="editorial-divider" />
        <h1 className="font-display text-5xl md:text-7xl mt-4 tracking-tight">The Editorial.</h1>
        <p className="text-lg text-[color:var(--forest-2)] mt-4 max-w-2xl">
          Guides, deep-dives and the coast's best-kept secrets — from the Hey GC editors and local contributors.
        </p>
      </motion.div>

      <div className="mt-10 flex flex-wrap gap-2">
        {CATEGORIES.map((c) => (
          <button
            key={c.key}
            onClick={() => setCat(c.key)}
            className={`chip ${cat === c.key ? "chip-active" : ""}`}
          >
            {c.label}
          </button>
        ))}
      </div>

      {hero && (
        <div className="mt-14">
          <GuideCard guide={hero} size="lg" />
        </div>
      )}

      <div className="mt-14 grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8">
        {rest.map((g, i) => <GuideCard key={g.id} guide={g} index={i} />)}
      </div>
    </div>
  );
}
